document.addEventListener("DOMContentLoaded", () => {
    const privacyInput = document.getElementById("privacy_accepted");
    const eulaInput = document.getElementById("eula_accepted");
    const loginButton = document.getElementById("sign-in-button");

    if (privacyInput) {
        privacyInput.addEventListener("change", () => toggleSignInButton());
    }

    if (eulaInput) {
        eulaInput.addEventListener("change", () => toggleSignInButton());
    }

    function toggleSignInButton() {
        if (checkIfConfirmed() && loginButton) {
            loginButton.disabled = false;
        } else {
            if (loginButton) {
                loginButton.disabled = true;
            }
        }
    }

    function checkIfConfirmed() {
        if (privacyInput && eulaInput) {
            return privacyInput.checked && eulaInput.checked;
        } else if (privacyInput) {
            return privacyInput.checked;
        } else if (eulaInput) {
            return eulaInput.checked;
        } else {
            return true;
        }
    }

    toggleSignInButton();
});
